export enum ApartmentFeature {
	PremiumPriceOnRequest = 21
}
